<script setup lang="ts">
import { useScenarioStore } from '@/stores/scenario'

const emit = defineEmits(['back-to-project', 'back-to-calculation-detail'])

const calculationStore = useScenarioStore()

const setCalculationToDraft = async () => {
  const currentCalculation = calculationStore.currentItem
  if (currentCalculation?.id) {
    try {
      await calculationStore.updateScenario(currentCalculation.id, { status: 'Draft' })
      emit('back-to-calculation-detail')
    } catch (error) {
      console.error('Failed to update calculation status to DRAFT:', error)
    }
  }
}
</script>

<template>
  <v-card class="text-center" variant="text">
    <v-icon color="error" size="44"> mdi-information-outline </v-icon>
    <v-card-text class="text-h6 pb-0"> Apologies, there is a server error. </v-card-text>
    <v-card-text class="text-h6 pt-0">
      Please go back to your simulation and run it again.
    </v-card-text>
    <div class="button-container">
      <v-btn elevation="0" class="text-none" @click="emit('back-to-project')">
        Return to the list simulation
      </v-btn>
      <v-btn elevation="0" class="text-none ml-4" @click="setCalculationToDraft">
        Return to the simulation detail
      </v-btn>
    </div>
  </v-card>
</template>

<style scoped>
.button-container {
  display: flex;
  justify-content: center;
  gap: 16px;
}
</style>
